import BaseLayout from './BaseLayout';
import BlankLayout from './BlankLayout';
/**
 * 布局注册表：RouteConfig.layout 的唯一出口。
 * 新增外壳只需在 types.ts 的 LayoutId 里加一个 id，并在此登记。
 */

export const layoutRegistry = {
  base: BaseLayout,
  blank: BlankLayout
};
export default layoutRegistry;